export default __webpack_public_path__ + "static/media/Vambraces of the Scattered Gods.18954025.jpg";